import { afterNextRender, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Input, ViewChild } from '@angular/core';
import { IBreadcrumbsItem } from '../../module/shared/components/breadcrumbs/breadcrumbs.component';
import { NewBuildingFlat } from '../../module/catalog/interfaces/catalog-item.interfece';
import { SharedModule } from '../../module/shared/shared.module';
import { NgClass } from '@angular/common';
import { aboutCompanyData } from './about-company.data';

@Component({
  selector: 'app-about-company',
  templateUrl: './about-company.component.html',
  styleUrl: './about-company.component.scss',
  imports: [SharedModule, NgClass],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AboutCompanyComponent {
  @Input() data: NewBuildingFlat | null = null;
  @ViewChild('video') videoPlayer!: ElementRef<HTMLVideoElement>;
  @ViewChild('layoutSwiper', { static: false }) layoutSwiperRef?: ElementRef;
  @ViewChild('layoutFeatures', { static: false }) layoutFeatures?: ElementRef;
  @ViewChild('layoutPartners', { static: false }) layoutPartners?: ElementRef;
  @ViewChild('layoutAchievement', { static: false }) layoutAchievement?: ElementRef;
  @ViewChild('pagination', { static: false }) pagination?: ElementRef;
  @ViewChild('featuresPagination', { static: false }) featuresPagination?: ElementRef;
  @ViewChild('partnersPagination', { static: false }) partnersPagination?: ElementRef;
  @ViewChild('achievementPagination', { static: false }) achievementPagination?: ElementRef;
  isOpenVideo = false;
  breadcrumbs: IBreadcrumbsItem[] = [
    {
      title: 'Главная',
      href: '/',
    },
    {
      title: 'О компании',
      routerLink: '',
    },
  ];
  isExpanded = [false, false];
  introImages = aboutCompanyData.introImages;
  features = aboutCompanyData.features;
  companySystems = aboutCompanyData.companySystems;
  partners = aboutCompanyData.partners;
  achievements = aboutCompanyData.achievements;

  constructor() {
    afterNextRender(() => {
      this.initSwiper();
    });
  }

  initSwiper() {
    const sliderElement = this.layoutSwiperRef?.nativeElement;

    Object.assign(sliderElement, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: this.pagination?.nativeElement,
        clickable: true,
      },
    });

    sliderElement.initialize();

    const featuresSlider = this.layoutFeatures?.nativeElement;

    Object.assign(featuresSlider, {
      slidesPerView: 2,
      spaceBetween: 10,
      pagination: {
        el: this.featuresPagination?.nativeElement,
        clickable: true,
      },
    });

    featuresSlider.initialize();

    const partnersSlider = this.layoutPartners?.nativeElement;

    Object.assign(partnersSlider, {
      slidesPerView: 3,
      spaceBetween: 10,
      pagination: {
        el: this.partnersPagination?.nativeElement,
        clickable: true,
      },
    });

    partnersSlider.initialize();

    const awardSlider = this.layoutAchievement?.nativeElement;

    Object.assign(awardSlider, {
      slidesPerView: 2,
      spaceBetween: 10,
      pagination: {
        el: this.achievementPagination?.nativeElement,
        clickable: true,
      },
    });

    awardSlider.initialize();
  }

  closeModals() {
    this.isOpenVideo = false;
    this.stopVideo();
  }

  openVideo() {
    this.isOpenVideo = true;
    this.startVideo();
  }

  startVideo(): void {
    this.videoPlayer.nativeElement.play().then();
  }

  stopVideo(): void {
    this.videoPlayer.nativeElement.pause();
    this.videoPlayer.nativeElement.currentTime = 0;
  }

  toggleText(index: number): void {
    this.isExpanded[index] = !this.isExpanded[index];
  }
}
